@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.gsb.vyapar.bhagya.util

import kotlinx.browser.window

actual object BuildConfig {
    actual fun isDebug(): Boolean {
        return isDebug
    }

    actual fun platform(): PlatformType {
        return PlatformType.JS
    }

    actual fun getVersion(): String {
        return appVersion
    }

    actual fun userAgent(): PlatformType {
        return getUserAgentJs()
    }

}

fun getUserAgentJs(): PlatformType {
    val userAgent = window.navigator.userAgent.lowercase()
    return when {
        userAgent.contains("android") -> PlatformType.ANDROID
        userAgent.contains("iphone") || userAgent.contains("ipad") || userAgent.contains("ipod") -> PlatformType.IOS
        else -> PlatformType.DESKTOP
    }
}